import { Checkbox, ContextMenu } from "client/CommonComponents";
import CatalogManagement from "./CatalogManagement";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogDashboardExcelData, getCatalogEquipmentGridData, getCatalogItemByAssetModelId, getCatalogManagementGridCount, getCatalogManagementGridData, getCategoryDropdownList, getDriveTrainDropdown, getEqClassCodeDropdown, getFuelTypeDropdown, getLengthDropdownList, getMakeDropdown, getManufacturerDropdownList, getModelDropdownList, getModelYearDropdown, getSeatingCapacityDropdownList, getUpdatedByDropdownList, getUpfitOptionDropdown, getVehicleTypeDropdownList, setCatalogDashboardExcelData } from "Store/Component/CatalogManagement/CatalogManagementAction";
import moment from "moment";
import completedIcon from '../../../assets/images/MyOrders/Myorder_Approved.svg'
import cancelledIcon from '../../../assets/images/MyOrders/Cancelled.svg'
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import GridDataFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction";
import { CATALOG_MANAGEMENT_ACTIVE_MENU, COLUMN_FILTERS } from "client/utils/constants/homeGridConstants";
import { CustomDateFilterComponent, CustomDropdownFilterComponent, CustomFilterComponent } from "../BulkOrder/Home/HomeHelper";
import permissions, { isAuthorized } from "client/utils/Permissions";
import userProfileSelectors from "../../../../redux/UserProfile/selectors"
import { base64ToArrayBuffer, CONSTRUCTION_EQUIPMENT_CATEGORY_WITH_CATEGORY_2, fetchGridPayload, popupInitialData, saveByteArray, SNOW_CATEGORY_WITH_CATGORY_TYPE, STANDARDIZED_EQUIPMENT_CATEGORY_WITH_CATEGORY_2 } from "utils";
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { getEditJobTitleData, getJobTitleExcelData, getJobTitleGridData, getSaveMultipleJobTitleStatus, setJobTitleExcelData, setSaveMultipleJobTitleStatus } from "Store/AssetManagement/JobTitle/JobTitleAction";
import { getCatalogUpdateVehicleLevel } from "Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction";
import { getDriverTitle } from "Store/AssetManagement/DriverTitle/DriverTitleAction";
import ConfirmationBee from "../../../assets/images/ConfirmationBee.svg";
import successBee from '../../../assets/images/SuccessBee.svg'
import { getSaveMultipleCatalogStatus, setSaveMultipleCatalogStatus } from "Store/AssetManagement/CatalogItem/CatalogItemAction";
import { constructionEquipmentRequiredFields, mowerRequiredFields, snowRequiredFields, standardizedEquipmentRequiredFields, trailerRequiredField, utilityVehicleRequiredField, vehicleRequiredFields } from "./CreateAsset/CreateAsset-Helper";
import { operations } from "redux/Navigation";
import navSelectors from "redux/Navigation/selectors"

const statusList = [
    {
        "text": "Active",
        "value": "Active",
        "label": "Active",
        "key": "Active"
    },
    {
        "text": "Inactive",
        "value": "Inactive",
        "label": "Inactive",
        "key": "Inactive"
    }
]

const globalStatusList = [
    {
        "text": "All",
        "value": "All",
        "label": "All",
        "key": "All"
    },
    {
        "text": "Active",
        "value": "Active",
        "label": "Active",
        "key": "Active"
    },
    {
        "text": "Inactive",
        "value": "Inactive",
        "label": "Inactive",
        "key": "Inactive"
    }
]

const clearFiltersValue = {
    vehicleType: "",
    equipmentType: "",
    bvSpecNo: "",
    description: "",
    eOneDescription:"",
    make: "",
    manufacturer: "",
    model: "",
    year: "",
    driveTrain: "",
    fuelType: "",
    upfit: "",
    length: "",
    seatingCapacity: "",
    eqClassCode: "",
    status: "",
    category: "",
    lastUpdatedDate: null,
    lastUpdatedBy: "",
    orderSearchBoxValue: "",
    globalStatus: globalStatusList?.find((status: any) => status.value === 'All'),
    dateRange: [],
    jobTitle: "",
    assignmentGroup: "",
    catalogItemId: "",
    businessRoleId: ""
}

const CatalogManagementContainer = () => {
    const wrapperRef = useRef<any>(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [paginationData, setPaginationData] = useState<any>({})
    const [pagesCount, setPagesCount] = useState<number>(0)
    const [serverTotal, setServerTotal] = useState(0)
    const [sortData, setSortData] = useState<any>('')
    const [searchValue, setSearchValue] = useState('')
    const [dateRange, setDateRange] = useState<any>([]);
    const [activeMenu, setActiveMenu] = useState(CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE)
    const [showActiveFilter, setShowActiveFilter] = useState<any>([])
    const [showGrid, setShowGrid] = useState<boolean>(false)
    const [globalStatus, setGlobalStatus] = useState<any>({
        "text": "All",
        "value": "All",
        "label": "All",
        "key": "All"
    })
    const [columnState, setColumnState] = useState<any>();
    const selectedIds: any = useRef([]);
    const gridData: any = useRef([]);
    const initialStatusSelected: any = useRef(null);
    const [, forceRender] = useState(0);
    const [popupContent, setPopupContent] = useState<any>(popupInitialData);
    const [selectedInActiveItems, setSelectedInactiveItems] = useState<any>(null);

    const lastUpdatedDate = useRef<any>(null);
    const selectLastUpdatedBy = useRef("");
    const selectVehicleType = useRef("");
    const selectStatus = useRef("");
    const selectEqClassCode = useRef("");
    const selectUpFit = useRef("");
    const selectFuelType = useRef('');
    const selectDriveTrain = useRef('');
    const selectYear = useRef('');
    const selectModel = useRef('');
    const selectMake = useRef('');
    const selectManufacturer = useRef("");
    const selectCategory = useRef("");
    const selectLength = useRef("");
    const selectSeatingCapacity = useRef("");
    const eOneFilterValue = useRef("")
    const descriptionFilter = useRef("")
    const bvSpecFilter = useRef("")
    const catalogItemId = useRef("");
    const businessRoleId = useRef("");
    const equipTypeFilter = useRef("");
    const selectAssignmentGroup = useRef("");
    const selectJobTitle = useRef("");

    const setJobTitle: any = useRef(null);
    const setAssignmentGroupList: any = useRef(null);
    const statusDropdownList: any = useRef(null);
    const globalStatusDropdownList: any = useRef(null);
    const eqClassCodeDropdownList: any = useRef(null);
    const upFitDropdownList: any = useRef(null);
    const fuelTypeDropdownList: any = useRef(null);
    const driveTrainDropdownList: any = useRef(null)
    const yearDropdownList: any = useRef(null);
    const modelDropdownList: any = useRef(null);
    const makeDropdownList: any = useRef(null);
    const updatedByDropdownList: any = useRef(null);
    const vehicleTypeDropdownList: any = useRef(null);
    const manufacturerDropdownList: any = useRef(null);
    const categoryDropdownList: any = useRef(null);
    const lengthDropdownList: any = useRef(null);
    const seatingCapacityDropdownList: any = useRef(null);

    const {
        catalogManagementGridData,
        catalogEquipmentGridData,
        catalogManagementGridCount,
        upfitOptionDropdownList,
        makeDropdown,
        modelDropdown,
        fuelTypeDropdown,
        eqClassCodeDropdown,
        modelYearDropdown,
        driveTrainDropdown,
        vehicleTypeDropdown,
        updatedByDropdown,
        manufacturerDropdown,
        categoryDropdown,
        lengthDropdown,
        seatingCapacityDropdown,
        catalogManagementGridFilters,
        getUserDetails,
        userData,
        vehicleGridFilters,
        mowerGridFilters,
        constructionEquipmentGridFilters,
        snowGridFilters,
        standardizedGridFilters,
        trailersGridFilters,
        utilityVehicleGridFilters,
        treeCareGridFilters,
        catalogDashboardExcelData,
        jobTitleGridData,
        jobTitleExcelData,
        catalogUpdateVehicleLevel,
        jobTitlesGridFilters,
        driverTitleList,
        isSavedMultipleCatalogStatus,
        isSavedMultipleJobTitleStatus,
        catalogItemByAssetModelId,
        editJobTitleDataById,
        navItem,
        headerNav
    }: any = useSelector(
        (state: any) => ({
            catalogManagementGridData: state.CatalogManagementReducer.catalogManagementGridData,
            catalogEquipmentGridData: state.CatalogManagementReducer.catalogEquipmentGridData,
            catalogManagementGridCount: state.CatalogManagementReducer.catalogManagementGridCount,
            upfitOptionDropdownList: state.CatalogManagementReducer.upfitOptionDropdownList,
            makeDropdown: state.CatalogManagementReducer.makeDropdownList,
            modelDropdown: state.CatalogManagementReducer.modelDropdownList,
            fuelTypeDropdown: state.CatalogManagementReducer.fuelTypeDropdownList,
            eqClassCodeDropdown: state.CatalogManagementReducer.eqClassCodeDropdownList,
            modelYearDropdown: state.CatalogManagementReducer.modelYearDropdownList,
            driveTrainDropdown: state.CatalogManagementReducer.driveTrainDropdownList,
            vehicleTypeDropdown: state.CatalogManagementReducer.vehicleTypeDropdownList,
            updatedByDropdown: state.CatalogManagementReducer.updatedByDropdownList,
            manufacturerDropdown: state.CatalogManagementReducer.manufacturerDropdownList,
            categoryDropdown: state.CatalogManagementReducer.categoryDropdownList,
            lengthDropdown: state.CatalogManagementReducer.lengthDropdownList,
            seatingCapacityDropdown: state.CatalogManagementReducer.seatingCapacityDropdownList,
            catalogManagementGridFilters: state.GridFiltersReducer.catalogManagementGridFilters,
            getUserDetails: state.UserProfile.getUserDetails,
            userData: userProfileSelectors.getUserDetails(state),
            vehicleGridFilters: state.GridFiltersReducer.vehicleGridFilters,
            mowerGridFilters: state.GridFiltersReducer.mowerGridFilters,
            constructionEquipmentGridFilters: state.GridFiltersReducer.constructionEquipmentGridFilters,
            snowGridFilters: state.GridFiltersReducer.snowGridFilters,
            standardizedGridFilters: state.GridFiltersReducer.standardizedGridFilters,
            trailersGridFilters: state.GridFiltersReducer.trailersGridFilters,
            utilityVehicleGridFilters: state.GridFiltersReducer.utilityVehicleGridFilters,
            treeCareGridFilters: state.GridFiltersReducer.treeCareGridFilters,
            catalogDashboardExcelData: state.CatalogManagementReducer.catalogDashboardExcelData,
            jobTitleGridData: state.JobTitleReducer.jobTitleGridData,
            jobTitleExcelData: state.JobTitleReducer.jobTitleExcelData,
            catalogUpdateVehicleLevel: state.CatalogDropDownUpdateReducers.catalogUpdateVehicleLevel,
            jobTitlesGridFilters: state.GridFiltersReducer.jobTitlesGridFilters,
            driverTitleList: state.DriverTitleReducer.driverTitleDropDownList,
            isSavedMultipleCatalogStatus: state.CatalogItemReducer.isSavedMultipleCatalogStatus,
            isSavedMultipleJobTitleStatus: state.JobTitleReducer.isSavedMultipleJobTitleStatus,
            catalogItemByAssetModelId: state.CatalogManagementReducer.catalogItemByAssetModelId,
            editJobTitleDataById: state.JobTitleReducer.editJobTitleDataById,
            navItem: navSelectors.GetNavItem(state),
            headerNav: navSelectors.GetHeaderNav(state)
        })
    )
  const dispatchHeaderNav = operations.dispatchHeaderNav(dispatch);
  const dispatchNav = operations.dispatchNav(dispatch);
  
    const addJobTitleToGrid = () => {
        if (isAuthorized(permissions.View_JobTitle) && list?.filter((item: any) => item.text === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES)?.length == 0) {
            list.push({
                id: 9,
                text: 'Job Titles',
                isActive: activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES,
                count: catalogManagementGridCount?.jobTitle
            })
            setShowActiveFilter(list)
        }else{
            setShowActiveFilter(list)
        }
    }

    const initializeStatusRefs = () => {
        initialStatusSelected.current = null
        selectedIds.current = []
        setSelectedInactiveItems(null);
    }

    useEffect(() => {
        if (getUserDetails?.permissions?.length > 0) {
          if(!isAuthorized(permissions.ViewCatalog) ){
            navigate('/ordermanagement/blank');
          } 
          addJobTitleToGrid()
        }
        dispatchNav(navItem);
        dispatchHeaderNav(headerNav);
      }, [getUserDetails?.permissions])

    useEffect(() => {
        if (isSavedMultipleCatalogStatus != null || isSavedMultipleJobTitleStatus != null) {
            if (isSavedMultipleCatalogStatus || isSavedMultipleJobTitleStatus) {
                const descriptionTxt = (<p>The status of the selected items has been successfully updated.</p>);
                setPopupContent({
                    ...popupContent,
                    titleImg: successBee,
                    title: "INFORMATION",
                    isDialogVisible: true,
                    isTitleWarning: false,
                    subtextcontent: descriptionTxt,
                    outlineBtnText: "OK",
                    isSingleConfirmationBtn: true,
                    popupOutlinebtnOnclick: () => {
                        callGridAPI()
                        hideDialog()
                    }
                });
            } else {
                const descriptionTxt = (<p>Issue occured while processing the request</p>);
                setPopupContent({
                    ...popupContent,
                    titleImg: ConfirmationBee,
                    title: "INFORMATION",
                    isDialogVisible: true,
                    isTitleWarning: false,
                    subtextcontent: descriptionTxt,
                    outlineBtnText: "OK",
                    isSingleConfirmationBtn: true,
                    popupOutlinebtnOnclick: () => {
                        hideDialog();
                    }
                })
            }
            initializeStatusRefs()
            dispatch(setSaveMultipleJobTitleStatus(null))
            dispatch(setSaveMultipleCatalogStatus(null))
        }
    }, [isSavedMultipleCatalogStatus, isSavedMultipleJobTitleStatus])


    const bindFiltersfromAPI = (filterObj: any, gridName: any) => {        
        if(gridName == activeMenu){
        selectStatus.current = filterObj['status'] ?? '';
        selectEqClassCode.current = filterObj['eqClassCode'] ?? '';
        selectUpFit.current = filterObj['upfit'] ?? '';
        selectFuelType.current = filterObj['fuelType'] ?? '';
        selectYear.current = filterObj['year'] ?? '';
        selectModel.current = filterObj['model'] ?? '';
        selectMake.current = filterObj['make'] ?? '';
        selectDriveTrain.current = filterObj['driveTrain'] ?? '';
        selectVehicleType.current = filterObj['vehicleType'] ?? '';
        selectLastUpdatedBy.current = filterObj['updatedBy'] ?? '';
        selectManufacturer.current = filterObj['manufacturer'] ?? '';
        selectCategory.current = filterObj['category'] ?? '';
        selectLength.current = filterObj['length'] ?? '';
        selectSeatingCapacity.current = filterObj['seatingCapacity'] ?? '';
        eOneFilterValue.current = filterObj['eOneDescription'] ?? '';
        descriptionFilter.current = filterObj['description'] ?? '';
        bvSpecFilter.current = filterObj['bvSpecNo'] ?? '';
        catalogItemId.current = filterObj['catalogItemId'] ?? '';
        businessRoleId.current = filterObj['businessRoleId'] ?? '';
        equipTypeFilter.current = '';
        lastUpdatedDate.current = filterObj['lastUpdatedDate'] ? new Date(filterObj['lastUpdatedDate']) : null;
        selectAssignmentGroup.current = filterObj['assignmentGroup'] ?? '';
        selectJobTitle.current = filterObj['jobTitle'] ?? '';
        }
    } 

    const checkFiltersExists = () => {
        if (((Object.keys(vehicleGridFilters)?.length == 1 && Object.keys(vehicleGridFilters)[0] != "activeMenu") || Object.keys(vehicleGridFilters)?.length > 1) ||
            ((Object.keys(mowerGridFilters)?.length == 1 && Object.keys(mowerGridFilters)[0] != "activeMenu") || Object.keys(mowerGridFilters)?.length > 1) ||
            ((Object.keys(constructionEquipmentGridFilters)?.length == 1 && Object.keys(constructionEquipmentGridFilters)[0] != "activeMenu") || Object.keys(constructionEquipmentGridFilters)?.length > 1) ||
            ((Object.keys(snowGridFilters)?.length == 1 && Object.keys(snowGridFilters)[0] != "activeMenu") || Object.keys(snowGridFilters)?.length > 1) ||
            ((Object.keys(standardizedGridFilters)?.length == 1 && Object.keys(standardizedGridFilters)[0] != "activeMenu") || Object.keys(standardizedGridFilters)?.length > 1) ||
            ((Object.keys(trailersGridFilters)?.length == 1 && Object.keys(trailersGridFilters)[0] != "activeMenu") || Object.keys(trailersGridFilters)?.length > 1) ||
            ((Object.keys(utilityVehicleGridFilters)?.length == 1 && Object.keys(utilityVehicleGridFilters)[0] != "activeMenu") || Object.keys(utilityVehicleGridFilters)?.length > 1) ||
            ((Object.keys(treeCareGridFilters)?.length == 1 && Object.keys(treeCareGridFilters)[0] != "activeMenu") || Object.keys(treeCareGridFilters)?.length > 1) ||
            ((Object.keys(jobTitlesGridFilters)?.length == 1 && Object.keys(jobTitlesGridFilters)[0] != "activeMenu") || Object.keys(jobTitlesGridFilters)?.length > 1)) {
            return true
        } else {
            return false
        }
    }
    const getGridName = (gridName: string) => {
        if (gridName === CONSTANTS.MOWER) {
            return CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS
        } else if (gridName === CONSTANTS.CONSTRUCTION_EQUIPMENT) {
            return CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT
        } else if (gridName === CONSTANTS.TRAILER) {
            return CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS
        } else if(gridName === CONSTANTS.STANDARIZED_EQUIPMENT){
            return CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED
        } else {
            return gridName
        }
    }

    useEffect(() => {
        if (getUserDetails?.userGridFilters?.length && !checkFiltersExists() ) {    
            const catalogFilters = getUserDetails?.userGridFilters?.find((page: any) => page.pageName === 'Catalog Management')?.gridFilter || []
            catalogFilters?.forEach((grid: any) => {
                let filterObj: any = {}
                let fromDateVal = ""
                let toDateVal = ""
                grid?.filterValues?.forEach((filterItem: any) => {
                    if (filterItem?.filterName == "FromDate") {
                        fromDateVal = filterItem?.filterValue ? filterItem?.filterValue : "";
                        if (fromDateVal != "" && toDateVal != "") {
                            filterObj["dateRange"] = (fromDateVal && toDateVal) ? [new Date(fromDateVal), new Date(toDateVal)] : null
                        }
                    } else if (filterItem?.filterName == "ToDate") {
                        toDateVal = filterItem?.filterValue ? filterItem?.filterValue : "";
                        if (fromDateVal != "" && toDateVal != "") {
                            filterObj["dateRange"] = (fromDateVal && toDateVal) ? [new Date(fromDateVal), new Date(toDateVal)] : null
                        }
                    } else if(filterItem?.filterName == "bvSpec"){
                        filterObj['bvSpecNo'] = filterItem?.filterValue
                    } else if(filterItem?.filterName == "updatedDate"){
                        filterObj['lastUpdatedDate'] = filterItem?.filterValue
                    } else {
                        filterObj[filterItem?.filterName] = filterItem?.filterValue
                    }
                })
                if (grid?.gridName === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE) {
                    dispatch(GridDataFiltersAction.setVehicleGridFilters(filterObj))
                } else if (grid?.gridName === CONSTANTS.MOWER) {
                    dispatch(GridDataFiltersAction.setMowerGridFilters(filterObj))
                } else if (grid?.gridName === CONSTANTS.CONSTRUCTION_EQUIPMENT) {
                    dispatch(GridDataFiltersAction.setConstructionEquipmentGridFilters(filterObj))
                } else if (grid?.gridName === CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW) {
                    dispatch(GridDataFiltersAction.setSnowGridFilters(filterObj))
                } else if (grid?.gridName === CONSTANTS.STANDARIZED_EQUIPMENT) {
                    dispatch(GridDataFiltersAction.setStandardizedGridFilters(filterObj))
                } else if (grid?.gridName === CONSTANTS.TRAILER) {
                    dispatch(GridDataFiltersAction.setTrailersGridFilters(filterObj))
                } else if (grid?.gridName === CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE) {
                    dispatch(GridDataFiltersAction.setUtilityVehicleGridFilters(filterObj))
                } else if (grid?.gridName === CATALOG_MANAGEMENT_ACTIVE_MENU.TREE_CARE) {
                    dispatch(GridDataFiltersAction.setTreeCareGridFilters(filterObj))
                } else if (grid?.gridName === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES) {
                    dispatch(GridDataFiltersAction.setJobTitlesGridFilters(filterObj))
                }

                bindFiltersfromAPI(filterObj, getGridName(grid?.gridName))
            });
        }
    }, [getUserDetails?.userGridFilters])

    useEffect(() => {
        dispatch(getCatalogManagementGridCount())
        dispatch(getUpfitOptionDropdown());
        dispatch(getMakeDropdown());
        dispatch(getEqClassCodeDropdown());
        dispatch(getDriveTrainDropdown());
        dispatch(getVehicleTypeDropdownList());
        dispatch(getUpdatedByDropdownList());
        statusDropdownList.current = statusList;
        globalStatusDropdownList.current = globalStatusList;
        addJobTitleToGrid();
    }, [])
    
    useEffect(() => {
        dispatch(getModelDropdownList(getGridFilterName(activeMenu)));
        dispatch(getFuelTypeDropdown('Vehicle'));
        setShowGrid(false)
        initializeStatusRefs()
        if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE) {
            dispatch(getModelYearDropdown(getGridFilterName(activeMenu)));
            vehicleColumn.splice(13, 0, lastUpdatedDateColumn)
            vehicleColumn.splice(14, 0, lastUpdateByColumn)
            if (!(isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))) {
                vehicleColumn.splice(1, 1)
            }
            setColumnState(vehicleColumn);
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS) {
            dispatch(getManufacturerDropdownList(getGridFilterName(activeMenu)));
            dispatch(getModelYearDropdown(getGridFilterName(activeMenu)));
            dispatch(getCategoryDropdownList(getGridFilterName(activeMenu)))
            equipmentColumn.splice(4, 0, makeColumn);
            equipmentColumn.splice(7, 0, yearColumn)
            equipmentColumn.splice(8, 0, categoryColumn)
            equipmentColumn.splice(9, 0, fuelTypeColumn)
            equipmentColumn.splice(12, 0, lastUpdatedDateColumn)
            equipmentColumn.splice(13, 0, lastUpdateByColumn)
            if (!(isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))) {
                equipmentColumn.splice(1, 1)
            }
            setColumnState(equipmentColumn);
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT) {
            dispatch(getManufacturerDropdownList(getGridFilterName(activeMenu)));
            dispatch(getCategoryDropdownList(getGridFilterName(activeMenu)));
            dispatch(getModelYearDropdown(getGridFilterName(activeMenu)));
            equipmentColumn.splice(4, 0, makeColumn);
            equipmentColumn.splice(6, 0, categoryColumn);
            equipmentColumn.splice(8, 0, yearColumn);
            equipmentColumn.splice(11, 0, lastUpdatedDateColumn)
            equipmentColumn.splice(12, 0, lastUpdateByColumn)
            if (!(isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))) {
                equipmentColumn.splice(1, 1)
            }
            setColumnState(equipmentColumn);
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW) {
            dispatch(getManufacturerDropdownList(getGridFilterName(activeMenu)));
            dispatch(getCategoryDropdownList(getGridFilterName(activeMenu)));
            dispatch(getModelYearDropdown(getGridFilterName(activeMenu)));
            equipmentColumn.splice(4, 0, makeColumn);
            equipmentColumn.splice(6, 0, categoryColumn)
            equipmentColumn.splice(8, 0, yearColumn)
            equipmentColumn.splice(9, 0, fuelTypeColumn)
            equipmentColumn.splice(12, 0, lastUpdatedDateColumn)
            equipmentColumn.splice(13, 0, lastUpdateByColumn)
            if (!(isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))) {
                equipmentColumn.splice(1, 1)
            }
            setColumnState(equipmentColumn);
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED) {
            dispatch(getManufacturerDropdownList(getGridFilterName(activeMenu)));
            dispatch(getModelYearDropdown(getGridFilterName(activeMenu)));
            equipmentColumn.splice(4, 0, makeColumn);
            equipmentColumn.splice(7, 0, yearColumn);
            equipmentColumn.splice(10, 0, lastUpdatedDateColumn)
            equipmentColumn.splice(11, 0, lastUpdateByColumn)
            if (!(isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))) {
                equipmentColumn.splice(1, 1)
            }
            setColumnState(equipmentColumn);
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS) {
            dispatch(getCategoryDropdownList(getGridFilterName(activeMenu)));
            dispatch(getManufacturerDropdownList(getGridFilterName(activeMenu)));
            dispatch(getLengthDropdownList(getGridFilterName(activeMenu)));
            equipmentColumn.splice(4, 0, makeColumn);
            equipmentColumn.splice(6, 0, categoryColumn)
            equipmentColumn.splice(8, 0, lengthColumn)
            equipmentColumn.splice(11, 0, lastUpdatedDateColumn)
            equipmentColumn.splice(12, 0, lastUpdateByColumn)
            if (!(isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))) {
                equipmentColumn.splice(1, 1)
            }
            setColumnState(equipmentColumn);
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE) {
            dispatch(getManufacturerDropdownList(getGridFilterName(activeMenu)));
            dispatch(getCategoryDropdownList(getGridFilterName(activeMenu)));
            dispatch(getModelYearDropdown(getGridFilterName(activeMenu)));
            dispatch(getSeatingCapacityDropdownList(getGridFilterName(activeMenu)));
            equipmentColumn.splice(4, 0, makeColumn);
            equipmentColumn.splice(6, 0, categoryColumn)
            equipmentColumn.splice(8, 0, yearColumn)
            equipmentColumn.splice(9, 0, seatingCapacityColumn);
            equipmentColumn.splice(12, 0, lastUpdatedDateColumn)
            equipmentColumn.splice(13, 0, lastUpdateByColumn)
            if (!(isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))) {
                equipmentColumn.splice(1, 1)
            }
            setColumnState(equipmentColumn);
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TREE_CARE) {
            dispatch(getModelYearDropdown(getGridFilterName(activeMenu)));
            dispatch(getManufacturerDropdownList(getGridFilterName(activeMenu)));
            equipmentColumn.splice(2, 0, makeColumn);
            equipmentColumn.splice(5, 0, yearColumn)
            if (!(isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))) {
                equipmentColumn.splice(1, 1)
            }
            setColumnState(equipmentColumn);
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES) {
            dispatch(getCatalogUpdateVehicleLevel());
            dispatch(getDriverTitle(true));
            jobTitleColumn.splice(7, 0, lastUpdatedDateColumn)
            jobTitleColumn.splice(8, 0, lastUpdateByColumn)
            if (!(isAuthorized(permissions?.View_JobTitle) || isAuthorized(permissions?.Create_Edit_JobTitle))) {
                jobTitleColumn.splice(1, 1)
            }
            setColumnState(jobTitleColumn);
        }
        bindFiltersToGrid()
        setTimeout(() => {
            setShowGrid(true);
        })
    }, [activeMenu, getUserDetails?.permissions])

    const filterValues = {
        [CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE]:  vehicleGridFilters,
        [CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS]:  mowerGridFilters,
        [CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT]:  constructionEquipmentGridFilters,
        [CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW]:  snowGridFilters,
        [CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED]:  standardizedGridFilters,
        [CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS]:  trailersGridFilters,
        [CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE]:  utilityVehicleGridFilters,
        [CATALOG_MANAGEMENT_ACTIVE_MENU.TREE_CARE]:  treeCareGridFilters,
        [CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES]:  jobTitlesGridFilters
    }

    const bindFiltersToGrid = () => {
        const currentActiveMenu = catalogManagementGridFilters?.activeMenu ? catalogManagementGridFilters?.activeMenu : CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE
        setActiveMenu(currentActiveMenu == "Job Titles" ? CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES : currentActiveMenu)
        setSearchValue(filterValues[currentActiveMenu]?.orderSearchBoxValue || '');
        if (filterValues[activeMenu]?.dateRange?.length) {
          setDateRange(filterValues[currentActiveMenu]?.dateRange)
        } else {
          setDateRange([]);
        }
        setGlobalStatus(filterValues[currentActiveMenu]?.globalStatus || {
            "text": "All",
            "value": "All",
            "label": "All",
            "key": "All"
        })
        selectStatus.current = filterValues[currentActiveMenu]?.status ?? '';
        selectEqClassCode.current = filterValues[currentActiveMenu]?.eqClassCode ?? '';
        selectUpFit.current = filterValues[currentActiveMenu]?.upfit ?? '';
        selectFuelType.current = filterValues[currentActiveMenu]?.fuelType ?? '';
        selectYear.current = filterValues[currentActiveMenu]?.year ?? '';
        selectModel.current = filterValues[currentActiveMenu]?.model ?? '';
        selectMake.current = filterValues[currentActiveMenu]?.make ?? '';
        selectDriveTrain.current = filterValues[currentActiveMenu]?.driveTrain ?? '';
        selectVehicleType.current = filterValues[currentActiveMenu]?.vehicleType ?? '';
        selectLastUpdatedBy.current = filterValues[currentActiveMenu]?.updatedBy ?? '';
        selectManufacturer.current = filterValues[currentActiveMenu]?.manufacturer ?? '';
        selectCategory.current = filterValues[currentActiveMenu]?.category ?? '';
        selectLength.current = filterValues[currentActiveMenu]?.length ?? '';
        selectSeatingCapacity.current = filterValues[currentActiveMenu]?.seatingCapacity ?? '';
        eOneFilterValue.current = filterValues[currentActiveMenu]?.eOneDescription ?? '';
        descriptionFilter.current = filterValues[currentActiveMenu]?.description ?? '';
        bvSpecFilter.current = filterValues[currentActiveMenu]?.bvSpecNo ?? '';
        catalogItemId.current = filterValues[currentActiveMenu]?.catalogItemId ?? '';
        businessRoleId.current = filterValues[currentActiveMenu]?.businessRoleId ?? '';
        equipTypeFilter.current = '';
        lastUpdatedDate.current = filterValues[currentActiveMenu]?.lastUpdatedDate ? new Date(filterValues[currentActiveMenu]?.lastUpdatedDate) : null;
        selectAssignmentGroup.current = filterValues[currentActiveMenu]?.assignmentGroup ?? '';
        selectJobTitle.current = filterValues[currentActiveMenu]?.jobTitle ?? '';
    }

    useEffect(() => {
        let gridDataTemp:any = [];
        if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE){
            gridDataTemp = catalogManagementGridData;
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
            gridDataTemp = jobTitleGridData;
        }else{
            gridDataTemp = catalogEquipmentGridData;
        }
        if (gridDataTemp?.data?.length) {
            const updatedOrderList = gridDataTemp?.data?.map((item: any) => ({
                ...item,
                lastUpdatedDate: moment(item.lastUpdatedDate).format("MM/DD/YYYY"),
                enableStatusToggle: initialStatusSelected?.current != null ? (initialStatusSelected?.current == item?.status ? true : false) : true,
                isStatusToggle: selectedIds?.current?.find((val?: any) => val == (activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? item?.assetModelId : item?.jobTitleId)) ? true : false,
            }));
            gridData.current = updatedOrderList;
        } else {
            if (!gridData) return;
            gridData.current = [];
        }
        setServerTotal(gridDataTemp?.totalRecords)
        if(initialStatusSelected?.current == 'Active'){
            setSelectedInactiveItems(null);
        }
    }, [catalogManagementGridData, catalogEquipmentGridData, jobTitleGridData, initialStatusSelected?.current])

    useEffect(() => {
        if (serverTotal && paginationData?.pageSize) {
          let pageSize = paginationData?.pageSize
          let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
          setPagesCount(tempPageCount)
        }
    }, [serverTotal, paginationData?.pageSize])


    const list = [
        {
            id: 1,
            text: CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE,
            isActive: activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE,
            count: catalogManagementGridCount?.vehicle
        },
        {
            id: 2,
            text: CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS,
            isActive: activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS,
            count: catalogManagementGridCount?.mowers
        },
        {
            id: 3,
            text: CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT,
            isActive: activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT,
            count: catalogManagementGridCount?.constructionEquipment
        },
        {
            id: 4,
            text: CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW,
            isActive: activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW,
            count: catalogManagementGridCount?.snow
        },
        {
            id: 5,
            text: CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED,
            isActive: activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED,
            count: catalogManagementGridCount?.standardized
        },
        {
            id: 6,
            text: CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS,
            isActive: activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS,
            count: catalogManagementGridCount?.trailers
        },
        {
            id: 8,
            text: CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE,
            isActive: activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE,
            count: catalogManagementGridCount?.utilityVehicle
        },
    ]

    useEffect(() => {
        addJobTitleToGrid()
    }, [catalogManagementGridCount])


    useEffect(()=>{
        if(catalogDashboardExcelData){
            const byteArray = base64ToArrayBuffer(catalogDashboardExcelData)
            saveByteArray('catalog_management', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            dispatch(setCatalogDashboardExcelData(null))
        }
    }, [catalogDashboardExcelData])

    useEffect(() => {
        if (jobTitleExcelData?.length) {
            const byteArray = base64ToArrayBuffer(jobTitleExcelData)
            saveByteArray('Job_Title', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            dispatch(setJobTitleExcelData(null))
        }
    }, [jobTitleExcelData])

    useEffect(() => {
        const dropdownList: any = (upfitOptionDropdownList || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        upFitDropdownList.current = dropdownList
    }, [upfitOptionDropdownList])

    useEffect(() => {
        const dropdownList: any = (makeDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        makeDropdownList.current = dropdownList
    }, [makeDropdown])

    useEffect(() => {
        const dropdownList: any = (modelDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        modelDropdownList.current = dropdownList
    }, [modelDropdown])

    useEffect(() => {
        const dropdownList: any = (fuelTypeDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        fuelTypeDropdownList.current = dropdownList
    }, [fuelTypeDropdown])

    useEffect(() => {
        const dropdownList: any = (eqClassCodeDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        eqClassCodeDropdownList.current = dropdownList
    }, [eqClassCodeDropdown])

    useEffect(() => {
        const dropdownList: any = (modelYearDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        yearDropdownList.current = dropdownList
    }, [modelYearDropdown])

    useEffect(() => {
        const dropdownList: any = (driveTrainDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        driveTrainDropdownList.current = dropdownList
    }, [driveTrainDropdown])

    useEffect(() => {
        let dropdownList: any = (vehicleTypeDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        vehicleTypeDropdownList.current = dropdownList?.filter((item:any)=>item.label != 'Both');
    }, [vehicleTypeDropdown])

    useEffect(() => {
        const dropdownList: any = (driverTitleList || [])?.map((item: any) => {
            return { label: item.text, key: item.value, ...item }
          })
          setJobTitle.current = dropdownList
    },[driverTitleList])

    useEffect(() => {
        const dropdownList: any = (updatedByDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        updatedByDropdownList.current = dropdownList
    }, [updatedByDropdown])

    useEffect(() => {
        const dropdownList: any = (manufacturerDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        manufacturerDropdownList.current = dropdownList
    }, [manufacturerDropdown])

    useEffect(() => {
        const dropdownList: any = (categoryDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        categoryDropdownList.current = dropdownList
    }, [categoryDropdown])

    useEffect(() => {
        const dropdownList: any = (lengthDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        lengthDropdownList.current = dropdownList
    }, [lengthDropdown])

    useEffect(() => {
        const dropdownList: any = (seatingCapacityDropdown || [])?.map((item: any) => {
          return { label: item.text, key: item.value, ...item }
        })
        seatingCapacityDropdownList.current = dropdownList
    }, [seatingCapacityDropdown])

    useEffect(() => {
        if(catalogUpdateVehicleLevel?.length){
            const dropdownList: any = catalogUpdateVehicleLevel?.map((item: any) => {
                return { label: item.text, key: item.value, ...item }
            })
            setAssignmentGroupList.current = dropdownList
        }
    },[catalogUpdateVehicleLevel])


    const filterDispatchController = (payload: any) => {
        if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE){
            dispatch(GridDataFiltersAction.setVehicleGridFilters({...payload, activeMenu: activeMenu}))
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS){
            dispatch(GridDataFiltersAction.setMowerGridFilters({...payload, activeMenu: activeMenu}))
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT){
            dispatch(GridDataFiltersAction.setConstructionEquipmentGridFilters({...payload, activeMenu: activeMenu}))
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW){
            dispatch(GridDataFiltersAction.setSnowGridFilters({...payload, activeMenu: activeMenu}))
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED){
            dispatch(GridDataFiltersAction.setStandardizedGridFilters({...payload, activeMenu: activeMenu}))
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS){
            dispatch(GridDataFiltersAction.setTrailersGridFilters({...payload, activeMenu: activeMenu}))
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE){
            dispatch(GridDataFiltersAction.setUtilityVehicleGridFilters({...payload, activeMenu: activeMenu}))
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TREE_CARE){
            dispatch(GridDataFiltersAction.setTreeCareGridFilters({...payload, activeMenu: activeMenu}))
        }else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
            dispatch(GridDataFiltersAction.setJobTitlesGridFilters({...payload, activeMenu: activeMenu}))
        }
    }

    const onSearchOrder = (e: any, isKeyPress?: any) => {
        setSearchValue((isKeyPress ? e :e?.target?.value))
        filterDispatchController({ orderSearchBoxValue: (isKeyPress ? e :e?.target?.value) })
    }
    
    const onDateRangeChange = (e: any) => {
        setDateRange(e);
        filterDispatchController({ dateRange: e })
    }

    const onChangeGlobalStatus = (e: any) => {
        setGlobalStatus(e);
        filterDispatchController({ globalStatus: e })
    }

    

    const CustomCell = (rowData: any, tableName?: any) => {        
        const [showContextualMenu, setShowContextualMenu] = useState(false);
        const onShowContextualMenu = (ev: React.MouseEvent<HTMLElement>) => {
            ev.preventDefault(); // don't navigate
            setShowContextualMenu(true);
        }
        let menuItems:any = [];
        if(tableName === 'catalog'){
            menuItems = [
                {
                    key: 'Edit',
                    text: 'Edit',
                    onClick: () => { 
                        if((isAuthorized(permissions?.ViewCatalog) || isAuthorized(permissions?.CreateEditCatalog))){
                            navigate(`/ordermanagement/catalogmanagement/createasset/${rowData?.assetModelId}/edit`, { state: { rowData } })
                        }
                    },
                },
                // {
                //     key: 'Copy',
                //     text: 'Copy',
                //     onClick: () => { 
                //         if(isAuthorized(permissions?.CreateEditCatalog)){
                //             navigate(`/ordermanagement/catalogmanagement/createasset/${rowData?.assetModelId}/copy`, { state: { rowData } })
                //         }
                //     },
                // }
            ]
        }else if(tableName === 'jobTitle'){
            menuItems = [
                {
                    key: 'Edit',
                    text: 'Edit',
                    onClick: () => { 
                        if((isAuthorized(permissions?.View_JobTitle) || isAuthorized(permissions?.Create_Edit_JobTitle))){
                            navigate(`/ordermanagement/catalogmanagement/createjobtitle/${rowData?.jobTitleId}`, { state: { rowData } })
                        }
                    },
                }
            ]
        }
         

        const onHideContextualMenu = () => setShowContextualMenu(false);
        const linkRef = useRef(null);
        return (
            <>
                <ContextMenu
                    items={menuItems}
                    hidden={showContextualMenu}
                    target={linkRef}
                    onItemClick={onHideContextualMenu}
                    onDismiss={onHideContextualMenu}
                    className='grid-context-menu'
                 data-attribute="CatalogManagement_container_Default_ContextMenu">
                    <a className="context-menu" ref={linkRef} href="/assetinventory" onClick={onShowContextualMenu}><span className='fa fa-ellipsis-h'> </span> </a>
                </ContextMenu>
            </>
        )
    }

    const [showContextualMenuAsset, setShowContextualMenuAsset] = useState(false);
    const onShowContextualMenuAsset = (ev: React.MouseEvent<HTMLElement>) => {
        ev.preventDefault(); // don't navigate
        setShowContextualMenuAsset(!showContextualMenuAsset);
    }
    const [showImportAssetPopup, setShowImportAssetPopup] = useState(false)
    const hideImportAssetPopup = () => {
        setShowImportAssetPopup(false)
    }

    const onHideContextualMenuAsset = () => setShowContextualMenuAsset(false);
    const linkRefAsset = useRef(null);
    
    const setFilters = (value: any) => {
        if (value !== '{}') {
          filterDispatchController(value)
        }
    }

    const removeFiltersOnTabChange = () => {
        if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE) {
            delete vehicleGridFilters.equipmentType
            delete vehicleGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setVehicleGridFilters(vehicleGridFilters))
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS) {
            delete mowerGridFilters.equipmentType
            delete mowerGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setMowerGridFilters(mowerGridFilters))
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT) {
            delete constructionEquipmentGridFilters.equipmentType
            delete constructionEquipmentGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setConstructionEquipmentGridFilters(constructionEquipmentGridFilters))
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW) {
            delete snowGridFilters.equipmentType
            delete snowGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setSnowGridFilters(snowGridFilters))
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED) {
            delete standardizedGridFilters.equipmentType
            delete standardizedGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setStandardizedGridFilters(standardizedGridFilters))
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS) {
            delete trailersGridFilters.equipmentType
            delete trailersGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setTrailersGridFilters(trailersGridFilters))
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE) {
            delete utilityVehicleGridFilters.equipmentType
            delete utilityVehicleGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setUtilityVehicleGridFilters(utilityVehicleGridFilters))
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TREE_CARE) {
            delete treeCareGridFilters.equipmentType
            delete treeCareGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setTreeCareGridFilters(treeCareGridFilters))
        } else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
            delete jobTitlesGridFilters.lastUpdatedBy
            dispatch(GridDataFiltersAction.setJobTitlesGridFilters(jobTitlesGridFilters))
        }
    }

    const handleOnClickFilter = (item: any) => {
        setShowGrid(false)
        const tempOrderList = JSON.parse(JSON.stringify(showActiveFilter));
        tempOrderList?.map((itemFilter: any) => {
            if (itemFilter.id === item.id) {
                itemFilter.isActive = true
            }
            if (itemFilter.id !== item.id) {
                itemFilter.isActive = false
            }
        })
        removeFiltersOnTabChange()
        setActiveMenu(item.text == "Job Titles" ? CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES : item.text)
        setShowActiveFilter(tempOrderList)
        dispatch(GridDataFiltersAction.setCatalogManagementGridFilters({activeMenu: item.text == "Job Titles" ? CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES : item.text}));
        setTimeout(() => {
            setShowGrid(true);
        })
    }

    const handleFilterClear = () => {
        setShowGrid(false);
        setSearchValue('')
        setDateRange([])
        setGlobalStatus({
            "text": "All",
            "value": "All",
            "label": "All",
            "key": "All"
        });
        selectVehicleType.current = ''
        selectEqClassCode.current = ''
        selectStatus.current = ''
        selectUpFit.current = ''
        selectFuelType.current = ''
        selectYear.current = ''
        selectModel.current = ''
        selectMake.current = ''
        selectDriveTrain.current = ''
        selectLastUpdatedBy.current = ''
        selectCategory.current = ''
        selectManufacturer.current = ''
        selectLength.current = ''
        selectSeatingCapacity.current = ''
        lastUpdatedDate.current = null
        eOneFilterValue.current = ''
        descriptionFilter.current = ''
        bvSpecFilter.current = ''
        catalogItemId.current = ''
        businessRoleId.current = ''
        equipTypeFilter.current = ''
        selectAssignmentGroup.current = ''
        selectJobTitle.current = ''
        filterDispatchController(clearFiltersValue)
        setTimeout(() => {
          setShowGrid(true);
        })
    }

    const getGridFilterName = (menu:any) => {
        if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE){
            return CONSTANTS.VEHICLE;
        }else if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS){
            return CONSTANTS.MOWER;
        }else if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT){
            return CONSTANTS.CONSTRUCTION_EQUIPMENT;
        }else if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW){
            return CONSTANTS.SNOW;
        }else if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED){
            return CONSTANTS.STANDARIZED_EQUIPMENT;
        }else if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS){
            return CONSTANTS.TRAILER;
        }else if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE){
            return CONSTANTS.UTILITY_VEHICLE;
        }else if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.TREE_CARE){
            return CONSTANTS.TREE_CARE;
        }else if(menu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
            return CONSTANTS.JOBTITLE;
        }
    }
      
    const getFilteredValues = () => {
        let filteredValues: any = [];
        if (bvSpecFilter.current != "" ) {
            filteredValues.push({ 'field': COLUMN_FILTERS.BV_SPEC, 'value': bvSpecFilter.current })
        }
        if(catalogItemId.current != "" && activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
            filteredValues.push({ 'field': COLUMN_FILTERS.CATALOG_ITEM_ID, 'value': catalogItemId?.current})
        }
        if(businessRoleId.current != "" && activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
            filteredValues.push({ 'field': COLUMN_FILTERS.JOB_TITLE_ID, 'value': businessRoleId?.current})
        }
        if (descriptionFilter.current != "") {
            filteredValues.push({ 'field': COLUMN_FILTERS.DESCRIPTION, 'value': descriptionFilter.current })
        }
        if (eOneFilterValue.current != "") {
            filteredValues.push({ 'field': COLUMN_FILTERS.EONE_DESCRIPTION, 'value': eOneFilterValue.current })
        }
        if (selectVehicleType.current != "") {
            filteredValues.push({ 'field': 'vehicleType', 'value': selectVehicleType.current })
        }
        if (selectStatus.current != "") {
            if(selectStatus.current != 'All')
                filteredValues.push({ 'field': 'status', 'value': selectStatus.current })
        }
        if (selectEqClassCode.current != "") {
            filteredValues.push({ 'field': 'eqClassCode', 'value': selectEqClassCode.current })
        }
        if (selectUpFit.current != "") {
            filteredValues.push({ 'field': 'upfit', 'value': selectUpFit.current })
        }
        if (selectFuelType.current != "") {
            filteredValues.push({ 'field': 'fuelType', 'value': selectFuelType.current })
        }
        if (selectYear.current != "") {
            filteredValues.push({ 'field': 'year', 'value': selectYear.current })
        }
        if (selectModel.current != "") {
            filteredValues.push({ 'field': 'model', 'value': selectModel.current })
        }
        if (selectMake.current != "") {
            filteredValues.push({ 'field': 'make', 'value': selectMake.current })
        }
        if (selectDriveTrain.current != "") {
            filteredValues.push({ 'field': 'driveTrain', 'value': selectDriveTrain.current })
        }
        if (selectLastUpdatedBy.current != "") {
            filteredValues.push({ 'field': 'updatedBy', 'value': selectLastUpdatedBy.current })
        }
        if (selectManufacturer.current != "") {
            filteredValues.push({ 'field': 'manufacturer', 'value': selectManufacturer.current })
        }
        if (selectCategory.current != "") {
            filteredValues.push({ 'field': 'category', 'value': selectCategory.current })
        }
        if (selectLength.current != "") {
            filteredValues.push({ 'field': 'length', 'value': selectLength.current })
        }
        if (selectSeatingCapacity.current != "") {
            filteredValues.push({ 'field': 'seatingCapacity', 'value': selectSeatingCapacity.current })
        }
        if (lastUpdatedDate.current != "" && lastUpdatedDate.current) {
            filteredValues.push({ 'field': COLUMN_FILTERS.UPDATED_DATE, 'value': moment(new Date(lastUpdatedDate.current)).format('YYYY-MM-DD') })
        }
        if (selectAssignmentGroup.current != "" && selectAssignmentGroup.current) {
            filteredValues.push({ 'field': 'assignmentGroup', 'value': selectAssignmentGroup.current })
        }
        if(selectJobTitle.current != "" && selectJobTitle.current){
            filteredValues.push({ 'field': 'jobTitle', 'value': selectJobTitle.current })
        }
        return filteredValues;
    }

    const debounceObject = [
        paginationData, activeMenu, searchValue, dateRange, selectVehicleType, selectStatus, selectEqClassCode, 
        selectUpFit, selectFuelType, selectYear,selectModel, selectMake, selectDriveTrain, selectLastUpdatedBy, 
        bvSpecFilter, catalogItemId, businessRoleId, descriptionFilter, eOneFilterValue, lastUpdatedDate, selectManufacturer, selectCategory, selectLength, selectSeatingCapacity, sortData, globalStatus, selectAssignmentGroup, selectJobTitle
    ]
    const globalDebounce = useDebounce(debounceObject, 500)
    
    const callGridAPI = () => {
        let payload: any = {
            "pageNumber": paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
            "pageSize": paginationData?.pageSize,
            "columnFilters": getFilteredValues(),
            "onlyActive": globalStatus?.value == 'Active' ? true : globalStatus?.value == 'Inactive' ? false : null,
            "gridFilterName": getGridFilterName(activeMenu),
            "loggedInMail": userData?.emailId
        }

        payload = fetchGridPayload(payload, dateRange, searchValue, sortData, false, null)
        if (payload.pageNumber && payload.pageSize) {
            if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE) {
                dispatch(getCatalogManagementGridData(payload));
            } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES) {
                dispatch(getJobTitleGridData(payload));
            } else {
                dispatch(getCatalogEquipmentGridData(payload));
            }
        }
    }

      useEffect(() => {
        callGridAPI()
      }, [globalDebounce])
    
      const fetchAction = useCallback((fetchData: any) => {
        if (fetchData.action && fetchData.action === "paging") {
          setPaginationData(fetchData.data)
        }
        if (fetchData.action && fetchData.action === "sorting") {
          setSortData(fetchData.data[0]);
        }
      }, [])

    const vehicleColumn = [
        {
            key: 'action',
            renderHeaderCell: () => null,
            width: 60,
            Cell: (row: any) => {
                return (
                  <Checkbox checked={row?.rowData?.isStatusToggle} onChange={(e?: any) => onChangeStatusToggle(e, row?.rowData)} disabled={!row?.rowData?.enableStatusToggle} className="mb-0"  data-attribute="CatalogManagement_container_Default_Checkbox" />
                );
              },
            sortable: false
        },
        {
            key: "Action",
            title: "Action",
            width: 60,
            Cell: (row: any) => CustomCell(row?.rowData, "catalog"),
            style: { textAlign: 'center' },
            id: 'action-column',
            sortable: false,
            FilterCell: (props: any) => <></>
        },
        {
            key: "catalogItemId",
            title: "Catalog Item #",
            width: 120,
            FilterCell: (props: any) => (
                <CustomFilterComponent {...props}  value={catalogItemId} />
            )
        },
        {
            key: "vehicleType",
            title: "Vehicle Type",
            width: 140,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={vehicleTypeDropdownList.current} setDropdown={selectVehicleType} />
            ),
        },
        {
            key: "bvSpecNo",
            title: "BV Spec #",
            width: 120,
            FilterCell: (props: any) => (
                <CustomFilterComponent {...props}  value={bvSpecFilter} />
            )
        },
        {
            key: "description",
            title: "Description",
            width: 180,
            FilterCell: (props: any) => (
                <CustomFilterComponent {...props}  value={descriptionFilter} />
            )
        },
        {
            key: "eOneDescription",
            title: "EOne Description",
            width: 180,
            FilterCell: (props: any) => (
                <CustomFilterComponent {...props}  value={eOneFilterValue} />
            )
        },
        {
            key: "make",
            title: "Make",
            width: 120,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={makeDropdownList.current} setDropdown={selectMake} />
            ),
        },
        {
            key: "model",
            title: "Model",
            width: 100,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={modelDropdownList.current} setDropdown={selectModel} />
            ),
        },
        {
            key: "year",
            title: "Year",
            width: 100,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={yearDropdownList.current} setDropdown={selectYear} />
            ),
        },
        {
            key: "driveTrain",
            title: "Drive Train",
            width: 100,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={driveTrainDropdownList.current} setDropdown={selectDriveTrain} />
            ),
        },
        {
            key: "fuelType",
            title: "Fuel Type",
            width: 120,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={fuelTypeDropdownList.current} setDropdown={selectFuelType} />
            ),
        },
        {
            key: "upfit",
            title: "Upfit",
            width: 130,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={upFitDropdownList.current} setDropdown={selectUpFit} />
            ),
        },
        {
            key: "eqClassCode",
            title: "Eq Class Code",
            width: 100,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={eqClassCodeDropdownList.current} setDropdown={selectEqClassCode} />
            ),
        },
        {
            key: "status",
            title: "Status",
            width: 100,
            Cell: (row: any) => <p><img src={`${row.rowData.status === 'Active' ? completedIcon : cancelledIcon}`} alt='Status Icon' title={row.rowData.status} className="me-1" />{row.rowData.status}</p>,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={statusDropdownList.current} setDropdown={selectStatus} />
            ),
        }
    ]
    const equipmentColumn:any = [
        {
            key: 'action',
            renderHeaderCell: () => null,
            width: 60,
            Cell: (row: any) => {
                return (
                  <Checkbox checked={row?.rowData?.isStatusToggle} onChange={(e?: any) => onChangeStatusToggle(e, row?.rowData)} disabled={!row?.rowData?.enableStatusToggle} className="mb-0"  data-attribute="CatalogManagement_container_Default_Checkbox_2" />
                );
              },
            sortable: false
        },
        {
            key: "Action",
            title: "Action",
            width: 60,
            Cell: (row: any) => CustomCell(row?.rowData, "catalog"),
            style: { textAlign: 'center' },
            id: 'action-column',
            sortable: false,
            FilterCell: (props: any) => <></>
        },
        {
            key: "catalogItemId",
            title: "Catalog Item #",
            width: 120,
            FilterCell: (props: any) => (
                <CustomFilterComponent {...props}  value={catalogItemId} />
            )
        },
        {
            key: "equipmentType",
            title: "Equipment Type",
            width: 140,
            FilterCell: (props: any) => (
                <CustomFilterComponent {...props}  value={bvSpecFilter} />
            )
        },
        {
            key: "model",
            title: "Model",
            width: 120,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={modelDropdownList.current} setDropdown={selectModel} />
            ),
        },
        {
            key: "description",
            title: "Description",
            width: 180,
            FilterCell: (props: any) => (
                <CustomFilterComponent {...props}  value={descriptionFilter} />
            )
        },
        {
            key: "status",
            title: "Status",
            width: 100,
            Cell: (row: any) => <p><img src={`${row.rowData.status === 'Active' ? completedIcon : cancelledIcon}`} alt='Status Icon' title={row.rowData.status} className="me-1" />{row.rowData.status}</p>,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={statusDropdownList.current} setDropdown={selectStatus} />
            ),
        }
    ];
    const lastUpdatedDateColumn = {
            key: "lastUpdatedDate",
            title: "Last Updated date",
            width: 130,
            FilterCell: (props: any) => (<CustomDateFilterComponent {...props} setDate={lastUpdatedDate} />)
        }
    const lastUpdateByColumn = {
            key: "lastUpdatedBy",
            title: "Last Updated by",
            width: 130,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={updatedByDropdownList.current} setDropdown={selectLastUpdatedBy} />
            ),
        }

    const makeColumn = {
        key: "manufacturer",
        title: "Make",
        width: 180,
        FilterCell: (props: any) => (
            <CustomDropdownFilterComponent {...props} options={manufacturerDropdownList.current} setDropdown={selectManufacturer} />
        ),
    }

    const categoryColumn = {
        key: "category",
        title: "Category",
        width: 180,
        FilterCell: (props: any) => (
            <CustomDropdownFilterComponent {...props} options={categoryDropdownList.current} setDropdown={selectCategory} />
        ),
    }

    const yearColumn = {
        key: "year",
        title: "Year",
        width: 180,
        FilterCell: (props: any) => (
            <CustomDropdownFilterComponent {...props} options={yearDropdownList.current} setDropdown={selectYear} />
        ),
    }

    const lengthColumn = {
        key: "length",
        title: "Length",
        width: 180,
        FilterCell: (props: any) => (
            <CustomDropdownFilterComponent {...props} options={lengthDropdownList.current} setDropdown={selectLength} />
        ),
    }

    const fuelTypeColumn = {
        key: "fuelType",
        title: "Fuel Type",
        width: 180,
        FilterCell: (props: any) => (
            <CustomDropdownFilterComponent {...props} options={fuelTypeDropdownList.current} setDropdown={selectFuelType} />
        ),
    }

    const seatingCapacityColumn = {
        key: "seatingCapacity",
        title: "Seating Capacity",
        width: 180,
        FilterCell: (props: any) => (
            <CustomDropdownFilterComponent {...props} options={seatingCapacityDropdownList.current} setDropdown={selectSeatingCapacity} />
        ),
    }

    const jobTitleColumn = [
        {
            key: 'action',
            renderHeaderCell: () => null,
            width: 20,
            Cell: (row: any) => {
                return (
                  <Checkbox checked={row?.rowData?.isStatusToggle} onChange={(e?: any) => onChangeStatusToggle(e, row?.rowData)} disabled={!row?.rowData?.enableStatusToggle} className="mb-0"  data-attribute="CatalogManagement_container_Default_Checkbox_3" />
                );
              },
            sortable: false
        },
        {
            key: "Action",
            title: "Action",
            width: 60,
            Cell: (row: any) => CustomCell(row?.rowData, "jobTitle"),
            style: { textAlign: 'center' },
            id: 'action-column',
            sortable: false,
            FilterCell: (props: any) => <></>
        },
        {
            key: "businessRoleId",
            title: "Job Item #",
            width: 120,
            FilterCell: (props: any) => (
                <CustomFilterComponent {...props}  value={businessRoleId} />
            )
        },
        {
            key: "jobTitle",
            title: "Job title",
            width: 140,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={setJobTitle.current} setDropdown={selectJobTitle} />
            ),
        },
        {
            key: "status",
            title: "Status",
            width: 100,
            Cell: (row: any) => <p><img src={`${row.rowData.status === 'Active' ? completedIcon : cancelledIcon}`} alt='Status Icon' title={row.rowData.status} className="me-1" />{row.rowData.status}</p>,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={statusDropdownList.current} setDropdown={selectStatus} />
            ),
        },
        {
            key: "assignmentGroup",
            title: AttributeName.ASSIGNMENT_GROUPS,
            width: 180,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent {...props} options={setAssignmentGroupList.current} setDropdown={selectAssignmentGroup} />
            ),
        }
    ]

    const getGlobalSearchPlaceHolder = (): string => {
        if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE){
            return 'Search By Vehicle Type, Make, Model etc...'
        } else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS) {
            return 'Search By Equipment Type, Manufacturer, Model etc...'
        } else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
            return 'Search By Job Title'
        } else {
            return 'Search By Equipment Type, Model etc...'
        }
    }

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
          document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    const handleClickOutside = (event: any) => {
          if (event.target.closest('.catalog-mgmt')) {
            setShowContextualMenuAsset(true)
          }
          else {
            setShowContextualMenuAsset(false)
          }
    }

    const alreadyHasGridFilterValues = useCallback(() => {
        let isAlreadyHasValues = true
        let GridFilterValueTemp: any = {}
        if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE) {
            GridFilterValueTemp = vehicleGridFilters
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.MOWERS) {
            GridFilterValueTemp = mowerGridFilters
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.CONSTRUCTION_EQUIPMENT) {
            GridFilterValueTemp = constructionEquipmentGridFilters
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.SNOW) {
            GridFilterValueTemp = snowGridFilters
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.STANDARIZED) {
            GridFilterValueTemp = standardizedGridFilters
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TRAILERS) {
            GridFilterValueTemp = trailersGridFilters
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.UTILITY_VEHICLE) {
            GridFilterValueTemp = utilityVehicleGridFilters
        } else if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.TREE_CARE) {
            GridFilterValueTemp = treeCareGridFilters
        } else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
            GridFilterValueTemp = jobTitlesGridFilters
        }
        Object.keys(clearFiltersValue)?.forEach((filterItem?: any) => {
            Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
                if (filterItem == gridItem) {
                    let val = gridItem
                    if (val == "globalStatus") {
                        if (GridFilterValueTemp[val]?.label != "All" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && GridFilterValueTemp[val]?.label != "") {
                            isAlreadyHasValues = false
                        }
                    } else if (GridFilterValueTemp[val] != "" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && val != "dateRange" && val != "globalStatus") {
                        isAlreadyHasValues = false
                    } else if (val == "dateRange") {
                        if (GridFilterValueTemp[val]?.length) {
                            isAlreadyHasValues = false
                        }
                    }
                }
            })
        })
        return isAlreadyHasValues
    }, [vehicleGridFilters, mowerGridFilters, constructionEquipmentGridFilters, snowGridFilters, standardizedGridFilters, trailersGridFilters, utilityVehicleGridFilters, treeCareGridFilters, jobTitlesGridFilters])


    const onExportExcel = () => {
        let payload: any = {
            "pageNumber": paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
            "pageSize": paginationData?.pageSize,
            "columnFilters": getFilteredValues(),
            "onlyActive": globalStatus?.value == 'Active' ? true : globalStatus?.value == 'Inactive' ? false : null,
            "gridFilterName": getGridFilterName(activeMenu),
            "loggedInMail": userData?.emailId
        }

        payload = fetchGridPayload(payload, dateRange, searchValue, sortData, false, null)

        if (payload.pageNumber && payload.pageSize) {
            if (activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE) {
                dispatch(getCatalogDashboardExcelData(payload, 'vehicle'));
            } else if(activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
                dispatch(getJobTitleExcelData(payload));
            }
            else {
                dispatch(getCatalogDashboardExcelData(payload, 'equipment'));
            }
        }
    }

    const handleAddNewJobTitle = (e:any) => {
        e.preventDefault();
        navigate(`/ordermanagement/catalogmanagement/CreateJobTitle`)
    }

    useEffect(() => {
        if (selectedIds?.current) {
            if (selectedIds?.current?.length > 0 && initialStatusSelected.current == 'Inactive') {
                if(selectedInActiveItems == null){
                    activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? dispatch(getCatalogItemByAssetModelId(selectedIds?.current[0])) : dispatch(getEditJobTitleData(selectedIds?.current[0]))
                }else{
                    const setB = new Set(selectedInActiveItems?.map((item?: any) => (activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? item?.assetModelId : item?.jobTitleId)));
                    let val = selectedIds?.current?.filter((item?: any) => !setB.has(item))
                    activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? dispatch(getCatalogItemByAssetModelId(val[0])) : dispatch(getEditJobTitleData(val[0]))
                }  
            }
        }
    }, [selectedIds?.current]);

    useEffect(() => {
        if (catalogItemByAssetModelId?.hasOwnProperty('assetModelId')) {
            let requiredFieldValues = {
                    nap: !catalogItemByAssetModelId?.isNationalAccountPricing,
                    assetModelId: catalogItemByAssetModelId?.assetModelId,
                    vehicleType: catalogItemByAssetModelId?.orderRequestSubType,
                    vehicleLevel: catalogItemByAssetModelId?.vehicleLevel,
                    make: catalogItemByAssetModelId?.make,
                    manufacturer: catalogItemByAssetModelId?.manufacturer,
                    model: catalogItemByAssetModelId?.model,
                    year: catalogItemByAssetModelId?.year,
                    noOfDoors: catalogItemByAssetModelId?.noOfDoors,
                    capacity: catalogItemByAssetModelId?.capacity,
                    truckSize: catalogItemByAssetModelId?.truckSize,
                    bvSpec: catalogItemByAssetModelId?.bvSpecNo,
                    upfit: catalogItemByAssetModelId?.upfitOption,
                    eqClassCode: catalogItemByAssetModelId?.eqClassCode,
                    driveTrain: catalogItemByAssetModelId?.driveTrain,
                    fuelType: catalogItemByAssetModelId?.fuelType,
                    catalogDescription: catalogItemByAssetModelId?.catalogDescription,
                    eOneDescription: catalogItemByAssetModelId?.eOneDescription,
                    detailedDescription: catalogItemByAssetModelId?.description,
                    poDescription1: catalogItemByAssetModelId?.poDesc1,
                    poDescription2: catalogItemByAssetModelId?.poDesc2,
                    actualPrice: catalogItemByAssetModelId?.budgetInfo?.actualPrice ?? 0,
                    budgetingPercent: catalogItemByAssetModelId?.budgetInfo?.budgetingPercent ,
                    budgetingPrice: catalogItemByAssetModelId?.budgetInfo?.budgetingPrice ?? 0,
                    leaseTerm: catalogItemByAssetModelId?.budgetInfo?.usefulLifeOrLeaseTerm,
                    monthlyDeprecation: catalogItemByAssetModelId?.budgetInfo?.monthlyDepreciation,
                    accountingClass: catalogItemByAssetModelId?.budgetInfo?.accountingClass,
                    logoed: catalogItemByAssetModelId?.budgetInfo?.logoed,
                    status: catalogItemByAssetModelId?.status,
                    price: catalogItemByAssetModelId?.price ?? 0,
                    stateAvailability: catalogItemByAssetModelId?.stateAvailability,
                    programStatus: catalogItemByAssetModelId?.programStatus,
                    annualHours: catalogItemByAssetModelId?.annualHours,
                    deckSize: catalogItemByAssetModelId?.deckSize,
                    deckType: catalogItemByAssetModelId?.deckType,
                    autonomous: catalogItemByAssetModelId?.autonomous,
                    category: catalogItemByAssetModelId?.categoryId ? catalogItemByAssetModelId?.category: catalogItemByAssetModelId?.style,
                    size: catalogItemByAssetModelId?.size,
                    length: catalogItemByAssetModelId?.length,
                    seatingCapacity: catalogItemByAssetModelId?.seatingCapacity,
                    enclosedCab: catalogItemByAssetModelId?.enclosedCab,
                    classType: catalogItemByAssetModelId?.vehicleType,
                    groupType: catalogItemByAssetModelId?.groupType,
                    vehicleClass: catalogItemByAssetModelId?.vehicleClass,
                    vehicleGrossWeightRating: catalogItemByAssetModelId?.grossVehicleWeightRatingId,
                    cdl: catalogItemByAssetModelId?.cdlRequiredId,
                    trim: catalogItemByAssetModelId?.trimId,
                    use: catalogItemByAssetModelId?.useTag,
                    category2: catalogItemByAssetModelId?.category2,
                    categoryType: catalogItemByAssetModelId?.categoryType,
                    type: catalogItemByAssetModelId?.type,
                    catalogItemId: catalogItemByAssetModelId?.catalogItemId,
                  }
            if(selectedInActiveItems == null){
                setSelectedInactiveItems([requiredFieldValues])
            }else if (selectedInActiveItems?.filter((item?: any) => item?.assetModelId == catalogItemByAssetModelId?.assetModelId) == 0) {
                let selectedInActiveItemTemp = selectedInActiveItems?.length ? JSON.parse(JSON.stringify(selectedInActiveItems)) : []
                selectedInActiveItemTemp.push(requiredFieldValues)
                setSelectedInactiveItems(selectedInActiveItemTemp)
            }
        }
    }, [catalogItemByAssetModelId])

    useEffect(() => {
        if (editJobTitleDataById?.hasOwnProperty('businessRoleId')) {
            if (selectedInActiveItems == null) {
                setSelectedInactiveItems([editJobTitleDataById])
            } else if (selectedInActiveItems?.filter((item?: any) => item?.businessRoleId == editJobTitleDataById?.businessRoleId) == 0) {
                let selectedInActiveItemTemp = selectedInActiveItems?.length ? JSON.parse(JSON.stringify(selectedInActiveItems)) : []
                selectedInActiveItemTemp.push(editJobTitleDataById)
                setSelectedInactiveItems(selectedInActiveItemTemp)
            }
        }
    }, [editJobTitleDataById])

    const onChangeStatusToggle = (e: any, rowData?: any) => {
        if (!rowData) return; 

        if (initialStatusSelected?.current == null) {
            initialStatusSelected.current = rowData?.status;
        }
        
        let valTemp: any = []
        gridData?.current?.map((item: any) => {
                if (activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES
                    ? item?.assetModelId === rowData?.assetModelId
                    : item?.jobTitleId === rowData?.jobTitleId) {
                    item.isStatusToggle = e?.target?.checked
                    valTemp.push(item)
                } else {
                    valTemp.push(item)
                }
        });
        gridData.current = valTemp;

        if (e?.target?.checked) {
            selectedIds.current = [...selectedIds.current, (activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? rowData?.assetModelId : rowData?.jobTitleId)];
        } else {
            const val = selectedIds?.current?.filter((item: any) => item !== (activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ?  rowData?.assetModelId : rowData?.jobTitleId)) ?? [];
            selectedIds.current = val;
            initialStatusSelected.current = val?.length == 0 ? null : initialStatusSelected?.current;
            if(rowData?.status == 'Inactive'){
                let selectedInActiveItemTemp = selectedInActiveItems?.filter((item?: any) => (activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? item?.assetModelId : item?.jobTitleId) !== (activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? rowData?.assetModelId : rowData?.jobTitleId))
                setSelectedInactiveItems(selectedInActiveItemTemp)
            }
        }
        forceRender((prev) => prev + 1);
    }

    const getRequiredFields = (assetType: any, item?: any) => {
        let RequiredFieldsTemp: any = [];
        if (assetType === CATALOG_MANAGEMENT_ACTIVE_MENU.VEHICLE) {
            let vehicleRequiredFieldsTemp = JSON.parse(JSON.stringify(vehicleRequiredFields));
            if (item?.vehicleType === CONSTANTS.PRODUCTION_VEHICLE ) {
                if(vehicleRequiredFieldsTemp?.filter((val?: any) =>  val == 'logoed')?.length > 1){
                    vehicleRequiredFieldsTemp = [...new Set(vehicleRequiredFieldsTemp)];
                }else if(vehicleRequiredFieldsTemp?.filter((val?: any) =>  val == 'logoed')?.length == 0){
                    vehicleRequiredFieldsTemp.push('logoed')
                }
                vehicleRequiredFieldsTemp = vehicleRequiredFieldsTemp?.filter((item?: any) => item !== "vehicleLevel");
            }else{
                if(vehicleRequiredFieldsTemp?.filter((val?: any) =>  val == 'logoed')?.length >= 1){
                    vehicleRequiredFieldsTemp = vehicleRequiredFieldsTemp?.filter((item?: any) => item !== "logoed");
                }
            }
            RequiredFieldsTemp = vehicleRequiredFieldsTemp
        }
        else if (assetType === 'Mowers') {
            RequiredFieldsTemp = mowerRequiredFields
        } else if (assetType === 'Trailers') {
            RequiredFieldsTemp = trailerRequiredField
        } else if (assetType === CONSTANTS.UTILITY_VEHICLE) {
            RequiredFieldsTemp = utilityVehicleRequiredField
        } else if (assetType === CONSTANTS.STANDARIZED_EQUIPMENT) {
            RequiredFieldsTemp = standardizedEquipmentRequiredFields
        } else if (assetType === CONSTANTS.CONSTRUCTION_EQUIPMENT) {
            RequiredFieldsTemp = constructionEquipmentRequiredFields
        } else if (assetType === CONSTANTS.SNOW) {
            RequiredFieldsTemp = snowRequiredFields
        } else if (assetType === CONSTANTS.JOBTITLE) {
            RequiredFieldsTemp = [
                "assignmentGroupId",
                "jobTitle"
            ]
        } else {
            return []
        }
        if (RequiredFieldsTemp) {
            if (item.nap) {
                RequiredFieldsTemp = RequiredFieldsTemp?.filter((item?: any) =>  item !== "actualPrice" && item !== "budgetingPercent" && item !== "budgetingPrice" && item !== "monthlyDeprecation");
            }
            if ((assetType === CONSTANTS.CONSTRUCTION_EQUIPMENT || assetType === CONSTANTS.STANDARIZED_EQUIPMENT) &&
                !(CONSTRUCTION_EQUIPMENT_CATEGORY_WITH_CATEGORY_2.includes(item?.category || '') || STANDARDIZED_EQUIPMENT_CATEGORY_WITH_CATEGORY_2.includes(item?.category || ''))) {
                RequiredFieldsTemp = RequiredFieldsTemp?.filter((item?: any) => item !== "category2");
            }
            if (assetType === CONSTANTS.SNOW && !SNOW_CATEGORY_WITH_CATGORY_TYPE.includes(item?.category || '')) {
                RequiredFieldsTemp = RequiredFieldsTemp?.filter((item?: any) => item !== "categoryType" );
            }
        }
        return RequiredFieldsTemp;
    }

    const onClickChangeStatus = (e?: any) => {
        e.preventDefault();        
        let missingFieldsId: any = [];
        if(initialStatusSelected?.current == 'Inactive'){
            selectedInActiveItems?.map((item?: any) => {
                if(activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES){
                let requiredFields = getRequiredFields(activeMenu, item);
                const missingFields =  requiredFields?.filter((field ?: any) => 
                    item?.[field] == null || item?.[field] == undefined || item?.[field]?.toString()?.trim()?.length == 0
                  );
                if (missingFields != null && missingFields?.length > 0) {
                    missingFieldsId.push(item?.catalogItemId)
                }
            }else{
                if((item?.jobTitle == null || item?.jobTitle == undefined || item?.jobTitle?.toString()?.trim()?.length == 0) || (item?.assignmentGroupId == null || item?.assignmentGroupId == undefined || item?.assignmentGroupId?.toString()?.trim()?.length == 0)){
                    missingFieldsId.push(item?.businessRoleId)
                }
            }
            });
        }
        if(missingFieldsId?.length > 0){
            const descriptionTxt = (<><p>One or more of the selected catalog items are missing data in the required fields. The catalog items with missing data are listed. Please review and enter the necessary information for each listed item to proceed with activation. The action cannot be completed until all required fields are filled.</p>
            {missingFieldsId?.map((item?: any) => <li>{item}</li>)}
            </>);
            setPopupContent({
                ...popupContent,
                titleImg: ConfirmationBee,
                title: "WARNING",
                isDialogVisible: true,
                isTitleWarning: true,
                subtextcontent: descriptionTxt,
                outlineBtnText: "OK",
                primaryBtnText: "",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                }
            })
        }else{
        const descriptionTxt = (<p>Are you sure you want to set the status as {initialStatusSelected?.current == 'Active' ? 'InActive' : 'Active'} for the selected items?</p>);
        setPopupContent({
            ...popupContent,
            titleImg: ConfirmationBee,
            title: "CONFIRMATION",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: descriptionTxt,
            outlineBtnText: "No",
            primaryBtnText: "Yes",
            isSingleConfirmationBtn: false,
            popupPrimarybtnOnclick: () => {                
                if (activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES) {
                    dispatch(getSaveMultipleCatalogStatus(
                        {
                            catalogIds: selectedIds.current,
                            isActive: initialStatusSelected.current == 'Active' ? false : true,
                            savedBy: userData?.emailId
                        }))
                } else {
                    dispatch(getSaveMultipleJobTitleStatus(
                        {
                            catalogIds: selectedIds.current,
                            isActive: initialStatusSelected.current == 'Active' ? false : true,
                            savedBy: userData?.emailId
                        }))
                }
            },
            popupOutlinebtnOnclick: () => {
                hideDialog();
            }
        })
    }
    }

    const hideDialog = () => {
        setPopupContent({ ...popupContent, isDialogVisible: false })
    };

    return (
        <CatalogManagement
            CustomCell={CustomCell}
            gridData={gridData}
            columnState={columnState}
            showContextualMenuAsset={showContextualMenuAsset}
            onShowContextualMenuAsset={onShowContextualMenuAsset}
            onHideContextualMenuAsset={onHideContextualMenuAsset}
            linkRefAsset={linkRefAsset}
            showImportAssetPopup={showImportAssetPopup}
            setShowImportAssetPopup={setShowImportAssetPopup}
            hideImportAssetPopup={hideImportAssetPopup}
            handleOnClickFilter={handleOnClickFilter}
            showActiveFilter={showActiveFilter}
            activeMenu={activeMenu}
            fetchAction={fetchAction}
            onSearchOrder={onSearchOrder}
            onDateRangeChange={onDateRangeChange}
            searchValue={searchValue}
            dateRange={dateRange}
            serverTotal={serverTotal}
            pagesCount={pagesCount}
            setFilters={setFilters}
            handleFilterClear={handleFilterClear}
            showGrid={showGrid}
            globalStatusDropdownList={globalStatusList}
            globalStatus={globalStatus}
            onChangeGlobalStatus = {onChangeGlobalStatus}
            getGlobalSearchPlaceHolder={getGlobalSearchPlaceHolder}
            wrapperRef={wrapperRef}
            alreadyHasGridFilterValues = {alreadyHasGridFilterValues}
            onExportExcel={onExportExcel}
            handleAddNewJobTitle = {handleAddNewJobTitle}
            onClickChangeStatus = {onClickChangeStatus}
            selectedIds = {selectedIds?.current}
            hideDialog = {hideDialog}
            popupContent = {popupContent}
        />
    )
}

export default CatalogManagementContainer;